"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.request = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var request = function request(_ref) {
  var data = _ref.data,
      _ref$market = _ref.market,
      market = _ref$market === void 0 ? _constants.MARKET_EN_US : _ref$market,
      method = _ref.method,
      params = _ref.params,
      url = _ref.url;
  return new Promise(function (resolve) {
    (0, _axios.default)({
      data: data,
      method: method,
      params: params,
      url: "".concat(url, "?market=").concat(market, "&plid=1")
    }).then(function (response) {
      resolve({
        data: response.data
      });
    }).catch(function (error) {
      resolve({
        error: error
      }); // track http errors here
    });
  });
};

exports.request = request;
var _default = _axios.default;
exports.default = _default;